<template>
  <b-button
    :variant="variant"
    :size="size"
    :type="type"
    :disabled="disabled"
    :class="buttonClasses"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span v-if="icon && iconPosition === 'left'" class="base-button__icon">
      <b-icon :icon="icon" aria-hidden="true"></b-icon>
    </span>
    <span v-if="label" class="base-button__label">{{ label }}</span>
    <span v-if="icon && iconPosition === 'right'" class="base-button__icon">
      <b-icon :icon="icon" aria-hidden="true"></b-icon>
    </span>
  </b-button>
</template>

<script>
export default {
  name: "BaseButton",
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    iconPosition: {
      type: String,
      default: "left",
      validator: (value) => ["left", "right"].includes(value),
    },
    variant: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "md",
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    buttonClasses() {
      return {
        "base-button": true,
        "base-button--block": this.block,
        "base-button--icon-only": this.iconOnly || (this.icon && !this.label),
      };
    },
  },
};
</script>

<style scoped>
.base-button {
  align-items: center;
  border-radius: 999px;
  box-sizing: border-box;
  display: inline-flex;
  gap: 8px;
  justify-content: center;
  line-height: 1;
  min-height: 42px;
  padding-left: 18px;
  padding-right: 18px;
}

.base-button--block {
  width: 100%;
}

.base-button--icon-only {
  align-items: center !important;
  border-radius: 50% !important;
  flex: 0 0 42px;
  gap: 0;
  height: 42px !important;
  justify-content: center !important;
  max-height: 42px;
  max-width: 42px;
  min-height: 42px !important;
  min-width: 42px !important;
  padding: 0 !important;
  width: 42px !important;
}

.base-button__icon,
.base-button__label {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: 1;
}

.base-button--icon-only .base-button__icon {
  height: 100%;
  width: 100%;
}

.base-button--icon-only .base-button__icon svg {
  display: block;
  margin: auto;
}
</style>
